import type criticalRu from '../ru/criticalRu'
import authEn from './authEn'
import urlEn from './url'

/** Английский аналог parts/i18n/ru/criticalRu. */
const criticalEn: typeof criticalRu = {
	url: urlEn,
	auth: authEn,
}

export default criticalEn
